import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';
import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconChevronLeft, homefieldIconChevronRight, homefieldIconSignCircle } from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HmfCarouselComponent } from '@dsg-tech/homefield-angular-cdk';
import { HomrCaliaLeggingsContentComponent } from './homr-calia-leggings-content.component';
import { SharedUtilsPipesModule } from '@shared/utils/pipes';

@NgModule({
	declarations: [
		HomrCaliaLeggingsContentComponent
	],
	imports: [
		CommonModule,
		HmfCarouselComponent,
		HomefieldIconLibraryModule,
		SharedUtilsPipesModule
	],
	exports: [
		HomrCaliaLeggingsContentComponent
	]
})
export class HomrCaliaLeggingsContentModule {
	constructor(private resolver: ComponentFactoryResolver, homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconChevronRight, homefieldIconChevronLeft, homefieldIconSignCircle]);
	 }

	public resolveComponentFactory(): ComponentFactory<HomrCaliaLeggingsContentComponent> {
		return this.resolver.resolveComponentFactory(HomrCaliaLeggingsContentComponent);
	}


}